// extracted by mini-css-extract-plugin
module.exports = {"CheckboxLabel__label":"CheckboxButton_CheckboxLabel__label__3d49p","CheckboxLabel__root":"CheckboxButton_CheckboxLabel__root__S_JJi","small":"CheckboxButton_small__2B4HN"};